module.exports = __webpack_public_path__ + "cc48796f92dc3fc2363e19be730cabbf.svg";